<template>
    <fieldset class="compo-form-item">
        <div class="compo-form-name">
            <legend class="compo-form-title form-label-required">문의내용</legend>
        </div>
        <div class="compo-form-body position-relative">
            <label class="visually-hidden" for="inquiryEmailContent">문의내용</label>
            <textarea @blur="confirmVaildEmailContent" v-model="inquiryEmailContent" id="inquiryEmailContent" class="form-control textarea" placeholder="문의내용(상품명, 발송목적 등)을 입력해주세요"></textarea>
            <!-- 유효성 검사 메시지 -->
            <template v-if="messageVaildEmailContent">
                <p class="form-info" :class="{'active': messageVaildEmailContent}">{{messageVaildEmailContent}}</p>
            </template>
        </div>
        <div class="compo-form-body">
            <label class="visually-hidden" for="budget">예산</label>
            <input type="text" @blur="confirmVaildEmailBudget" v-model="budget" id="budget" placeholder="예산을 입력해주세요" class="form-control">
            <!-- 유효성 검사 메시지 -->
            <template v-if="messageVaildBudget">
                <p class="form-info" :class="{'active': messageVaildBudget}">{{messageVaildBudget}}</p>
            </template>
            <p class="form-info form-info--always">※ 300만원 이상의 구매 시 할인율의 폭이 커지며 구체적인 할인율은 상품에 따라 달라질 수 있습니다.</p>
        </div>
    </fieldset>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
    data() {
        return {
            inquiryEmailContent: '',        // 문의 내용 === 이메일 내용
            budget: '',                     // 예상 예산 입력값
            messageVaildEmailContent: '',   // 이메일 내용 유효성 검사 메시지
            messageVaildBudget: '',         // 예산 입력값 유효성 검사 메시지
        }
    },

   computed: {        
        emailContentConvertedToHtml(){      // 개행 표기(\n)를 HTML <br> 태그 변환
            return this.inquiryEmailContent.replace(/(?:\r\n|\r|\n)/g, '<br>');
        },
   },

    methods: {
        // Store
        ...mapMutations({
            setInquiryEmailContent: 'bulkBuyingStore/setInquiryEmailContent',
            setBudget: 'bulkBuyingStore/setBudget'
        }),

        // 문의 내용 필수값 유효성 검사
        confirmVaildEmailContent(){
            if(!this.emailContentConvertedToHtml){
                this.messageVaildEmailContent = '문의하실 내용을 입력해주세요.';
            }else{
                this.messageVaildEmailContent = '';
            }
            // Store에 값 보내기
            this.setInquiryEmailContent(this.emailContentConvertedToHtml);
        },

        // 문의 예산 필수값 유효성 검사
        confirmVaildEmailBudget(){
            if(!this.budget){
                this.messageVaildBudget ='예산을 입력해주세요.';
            }else{
                this.messageVaildBudget = '';
            }
            // Store에 값 보내기
            this.setBudget(this.budget);
        },
    }
}
</script>

<style lang="scss" scoped>
.form-info--always{
    display: block;
    font-size: 12px;
    color: var(--gray-40);
}
</style>